import { Outlet } from "react-router-dom";

/**
 * Constrains routed pages to the standard content width and centers them.
 * Applied to every page except the Kanban dashboard, which needs full width.
 */
const CenteredLayout = () => (
    <div className="max-w-content mx-auto w-full h-full">
        <Outlet />
    </div>
);

export default CenteredLayout;
